import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Star, Route } from "lucide-react";
import { TspBadge } from "../../../components/primitives";
import { formatNumber, initialsOf } from "../../../utils/tspFormat";
import { findStatus } from "../directoryModel";

// One bus leader in the directory: identity, where they are based, what they
// are doing now, headline numbers and a way to contact them.
export default function LeaderCard({ leader }) {
  const status = findStatus(leader.status);

  return (
    <article className="tsp-leader-card" aria-label={leader.name}>
      <header className="tsp-leader-head">
        <span className="tsp-leader-avatar" aria-hidden="true">
          {initialsOf(leader.name)}
        </span>
        <div className="tsp-leader-id">
          <h3>{leader.name}</h3>
          <span className="tsp-leader-team">{leader.team}</span>
        </div>
        {status && <TspBadge tone={status.tone}>{status.label}</TspBadge>}
      </header>

      <dl className="tsp-leader-meta">
        <div>
          <dt>
            <MapPin size={13} aria-hidden="true" /> Base
          </dt>
          <dd>
            {leader.base}, {leader.state}
          </dd>
        </div>
        <div>
          <dt>
            <Route size={13} aria-hidden="true" /> Journey
          </dt>
          <dd>
            {leader.currentJourneyId ? (
              <Link to={`/tsp/journeys/${leader.currentJourneyId}`}>{leader.currentJourneyName}</Link>
            ) : (
              <span className="tsp-muted-text">No journey running</span>
            )}
          </dd>
        </div>
      </dl>

      <ul className="tsp-leader-stats" aria-label="Leader statistics">
        <li>
          <strong>{leader.journeysCompleted}</strong>
          <span>Journeys</span>
        </li>
        <li>
          <strong>{formatNumber(leader.books)}</strong>
          <span>Books</span>
        </li>
        <li>
          <strong className="tsp-leader-rating">
            <Star size={13} aria-hidden="true" /> {leader.rating.toFixed(1)}
          </strong>
          <span>Response</span>
        </li>
      </ul>

      <div className="tsp-leader-actions">
        {leader.phone ? (
          <a href={`tel:${leader.phone.replace(/\s+/g, "")}`} className="tsp-btn tsp-btn-outline-primary tsp-btn-sm" aria-label={`Call ${leader.name}`}>
            <Phone size={13} aria-hidden="true" /> Call
          </a>
        ) : (
          <span className="tsp-btn tsp-btn-outline tsp-btn-sm tsp-btn-disabled" aria-disabled="true">
            <Phone size={13} aria-hidden="true" /> No phone
          </span>
        )}
        {leader.email ? (
          <a href={`mailto:${leader.email}`} className="tsp-btn tsp-btn-outline tsp-btn-sm" aria-label={`Email ${leader.name}`}>
            <Mail size={13} aria-hidden="true" /> Email
          </a>
        ) : (
          <span className="tsp-btn tsp-btn-outline tsp-btn-sm tsp-btn-disabled" aria-disabled="true">
            <Mail size={13} aria-hidden="true" /> No email
          </span>
        )}
      </div>
    </article>
  );
}
